import { useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { usePushNotifications } from '../../hooks/usePushNotifications';

/**
 * When a user signs in on a device that already allowed notifications, point
 * this browser's subscription at that user. Other devices stay subscribed.
 */
const PushSubscriptionSync = () => {
  const { user } = useContext(AuthContext);
  const { syncExistingSubscription } = usePushNotifications();
  const syncedUserId = useRef(null);

  useEffect(() => {
    const userId = user?.id;
    if (!userId || syncedUserId.current === userId) return;
    syncedUserId.current = userId;
    syncExistingSubscription();
  }, [user?.id, syncExistingSubscription]);

  return null;
};

export default PushSubscriptionSync;
